import React, { useEffect, useState } from 'react'
import { AppDispatch } from '../../../store/app';
import { useDispatch } from 'react-redux';
import { getEmailSupportList } from '../../../store/SendEmailSupportSlice';
import SendSupportListTable from './SendSupportListTable';
import ToolBar from '../../../components/ToolBar';
import SendSupportForm from './SendSupportForm';

const SendEmail: React.FC = () => {
    const dispatch: AppDispatch = useDispatch();

    const [tableloading, setTableLoading] = useState<boolean>(false);
    const [emailSupportPaginationData, setEmailSupportPaginationData] = useState<any>({
        current: 1,
        page_size: 10,
    });
    const [emailSupportListData, setEmailSupportListData] = useState<any[]>([]);
    const [emailSupportTotalData, setEmailSupportTotalData] = useState<any>(0);    

    const getList = (data?: any) => {
        setTableLoading(true);
        const payload = {
            ...data,
            current: data?.current ?? emailSupportPaginationData?.current ?? 1,
            page_size: data?.page_size ?? emailSupportPaginationData?.page_size ?? 10,
            // user_id: '661e722d74bca72daa7d1a3b',
        };
        dispatch(getEmailSupportList(payload))
            .then((res: any) => {
                setEmailSupportListData(res?.data?.data);
                setEmailSupportTotalData(res?.data?.total_data);
                setTableLoading(false);
            })
            .catch(() => {
                setEmailSupportListData([]);
                setEmailSupportTotalData(0)
                setTableLoading(false);
            });
    };

    const token = localStorage.getItem('token');
    useEffect(() => {
        if (token && token !== 'undefined') {
            getList();            
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return (
        <>
            <ToolBar title={'Send Email Support'} />
            <SendSupportForm getList={getList} />
            <SendSupportListTable
                listData={emailSupportListData}
                setListData={setEmailSupportListData}
                tableloading={tableloading}
                getList={getList}
                totalData={emailSupportTotalData}
                setTableLoading={setTableLoading}
                paginationData={emailSupportPaginationData}
                setPaginationData={setEmailSupportPaginationData}
            />
        </>
    )
}

export default SendEmail